var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuickAndEasy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 223.49 86.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-miterlimit:10;}.cls-1,.cls-2{fill:none;}.cls-1,.cls-2,.cls-3{stroke:#218cff;stroke-linecap:round;}.cls-2{stroke-width:3px;}.cls-2,.cls-3{stroke-linejoin:round;}.cls-4{fill:#218cff;}.cls-3{fill:#fff;stroke-width:1.17px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.3,22.08l23.46-1.26c23.84-.5,27.64-13.97,19.03-13.79l-75.34,2.36s-6.76,.55-11.36,6.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M164.91,34.95l23.4-.49c23.84-.5,27.64-13.97,19.03-13.79l-39.94,1.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M152.97,48.59l23.4-.49c23.84-.5,27.64-13.97,19.03-13.79l-38.17,.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.24,62.01h0c23.84-.5,27.64-13.97,19.03-13.79l-9.13,.19"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.19,22.08l-23.46-1.26C-.11,20.32-3.9,6.85,4.7,7.03l75.34,2.36s6.76,.55,11.36,6.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.58,34.95l-23.4-.49c-23.84-.5-27.64-13.97-19.03-13.79l39.94,1.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.52,48.59l-23.4-.49c-23.84-.5-27.64-13.97-19.03-13.79l38.17,.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.26,62.01h0c-23.84-.5-27.64-13.97-19.03-13.79l9.13,.19"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.33,30.56c-1.06,1.23-2.01,2.55-2.83,3.96l-9.52-6.79-.88-.62,2.82-3.96,.88,.63,9.52,6.79Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 65.34,
    y: 21.49,
    width: 15.72,
    height: 5.39,
    transform: "translate(135.4 -21.35) rotate(125.51)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M139.93,50.96c0,15-12.16,27.17-27.16,27.17s-27.17-12.17-27.17-27.17,12.17-27.17,27.17-27.17,27.16,12.16,27.16,27.17Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M115.89,6.12v13.94c-1.02-.09-2.07-.14-3.12-.14s-2.1,.05-3.12,.14V6.12h6.25Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 102.69,
    y: 0.59,
    width: 20.17,
    height: 6.92
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M150.39,27.1l-.88,.62-9.58,6.79c-.82-1.4-1.77-2.73-2.83-3.96l9.59-6.79,.88-.63,2.82,3.96Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 142.43,
    y: 21.49,
    width: 15.72,
    height: 5.39,
    transform: "translate(82.68 -112.2) rotate(54.49)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112.77,15.86c-19.39,0-35.1,15.71-35.1,35.1s15.71,35.09,35.1,35.09,35.1-15.71,35.1-35.09-15.71-35.1-35.1-35.1Zm0,62.27c-15,0-27.17-12.17-27.17-27.17s12.17-27.17,27.17-27.17,27.16,12.16,27.16,27.17-12.16,27.17-27.16,27.17Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 112.74,
    y1: 76.58,
    x2: 112.75,
    y2: 70.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-2"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 99.94,
    y1: 73.14,
    x2: 103.13,
    y2: 67.61
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 90.57,
    y1: 63.75,
    x2: 96.1,
    y2: 60.56
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-4"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 87.15,
    y1: 50.93,
    x2: 93.53,
    y2: 50.94
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-5"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 90.6,
    y1: 38.13,
    x2: 96.12,
    y2: 41.32
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-6"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 99.98,
    y1: 28.76,
    x2: 103.17,
    y2: 34.29
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-7"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 112.8,
    y1: 25.34,
    x2: 112.79,
    y2: 31.72
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-8"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 125.61,
    y1: 28.78,
    x2: 122.41,
    y2: 34.31
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-9"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 134.98,
    y1: 38.17,
    x2: 129.44,
    y2: 41.36
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-10"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 138.39,
    y1: 50.99,
    x2: 132.01,
    y2: 50.98
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-11"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 134.95,
    y1: 63.8,
    x2: 129.42,
    y2: 60.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "_Radial_Repeat_-12"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 125.56,
    y1: 73.16,
    x2: 122.37,
    y2: 67.63
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M111.64,49.73c-.65,.65-.65,1.71,0,2.36h0c.65,.65,1.71,.65,2.36,0l9.54-11.31c.3-.39-.2-.89-.59-.59l-11.31,9.54Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickAndEasy);
export default __webpack_public_path__ + "static/media/quickAndEasy.6d6c7d562df9da2209d9726f9cbf6ce8.svg";
export { ForwardRef as ReactComponent };